import { render, staticRenderFns } from "./MContributionPostList.vue?vue&type=template&id=546ff724&scoped=true&"
import script from "./MContributionPostList.vue?vue&type=script&lang=js&"
export * from "./MContributionPostList.vue?vue&type=script&lang=js&"
import style0 from "./MContributionPostList.vue?vue&type=style&index=0&id=546ff724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546ff724",
  null
  
)

export default component.exports